export enum LegalDocumentId {
  TermsAndConditions = "terms-and-conditions",
  PrivacyPolicy = "privacy-policy",
  ReturnAndRefund = "cancellation-return-refund",
  HealthSafety = "health-and-safety",
  CookiePolicy = "cookie-policy",
  Eula = "eula",
}

export enum LegalDocumentName {
  TermsAndConditions = "Terms and Conditions",
  PrivacyPolicy = "Privacy Policy",
  ReturnAndRefund = "Return and Refund",
  HealthSafety = "Health Safety Warnings",
  CookiePolicy = "Cookie Policy",
  Eula = "eula",
}
export interface LegalDocument {
  id: LegalDocumentId;
  name: LegalDocumentName;
}

export const LegalDocumentList: LegalDocument[] = [
  {
    id: LegalDocumentId.TermsAndConditions,
    name: LegalDocumentName.TermsAndConditions,
  },
  { id: LegalDocumentId.PrivacyPolicy, name: LegalDocumentName.PrivacyPolicy },
  {
    id: LegalDocumentId.ReturnAndRefund,
    name: LegalDocumentName.ReturnAndRefund,
  },
  {
    id: LegalDocumentId.HealthSafety,
    name: LegalDocumentName.HealthSafety,
  },
  {
    id: LegalDocumentId.CookiePolicy,
    name: LegalDocumentName.CookiePolicy,
  },
  {
    id: LegalDocumentId.Eula,
    name: LegalDocumentName.Eula,
  },
];
